import { TipoEstado, TipoEstadoFactory } from './tipo-estado-solicitud';

export class Solicitudes {
  Id: number;
  TIPO: string;
  PRIORIDAD: number;
  SITUACION: string;
  SITUACION_DESCRIPCION: string;
  ESTADO: string;
  ESTADO_DESCRIPCION: string;
  FECHA_ALTA: Date;
  FECHA_LIMITE: Date;
  FECHA_FIN: Date;
  CLIENTE: number;
  NOMBRE_CLIENTE: string;
  TIPO_ESTADO: TipoEstado;
  ID_USUARIO: number;
  USUARIO: string;
  ESTE_USUARIO_TIENE_QUE_APROBARLA: boolean;
  NOMBREYAPES_USUARIO_PDTE_APROBACION: string;
  PDTE_APROBACION: boolean;
  APROBADA?: boolean;
  canReturn: boolean;
  hasShowUser: boolean;
  ID_DEPARTAMENTO: string;
  SERIE_DOCUMENTAL: string;
  NOMBRE_SERIE: string;
  PROVEEDOR: string;

  constructor() { }

  static toModel(json: string): Solicitudes {
    const data = JSON.parse(json);
    const toReturn = new Solicitudes();
    toReturn.Id = data.Id;
    toReturn.TIPO = data.TIPO;
    toReturn.PRIORIDAD = data.PRIORIDAD;
    toReturn.SITUACION = data.SITUACION;
    toReturn.SITUACION_DESCRIPCION = data.SITUACION_DESCRIPCION;
    toReturn.ESTADO = data.ESTADO;
    toReturn.ESTADO_DESCRIPCION = data.ESTADO_DESCRIPCION;
    toReturn.FECHA_ALTA = data.FECHA_ALTA;
    toReturn.FECHA_LIMITE = data.FECHA_LIMITE;
    toReturn.FECHA_FIN = data.FECHA_FIN;
    toReturn.CLIENTE = data.CLIENTE;
    toReturn.NOMBRE_CLIENTE = data.NOMBRE_CLIENTE;
    toReturn.TIPO_ESTADO = TipoEstadoFactory.getTipoEstado(data.TIPO_ESTADO);
    toReturn.ID_USUARIO = data.ID_USUARIO;
    toReturn.USUARIO = data.USUARIO;
    toReturn.PDTE_APROBACION = data.PDTE_APROBACION;
    toReturn.ESTE_USUARIO_TIENE_QUE_APROBARLA = data.ESTE_USUARIO_TIENE_QUE_APROBARLA;
    toReturn.NOMBREYAPES_USUARIO_PDTE_APROBACION = data.NOMBREYAPES_USUARIO_PDTE_APROBACION;
    toReturn.APROBADA = data.APROBADA;
    toReturn.canReturn = data.PUEDE_HACER_DEVOLUCION;
    toReturn.hasShowUser = data.MOSTRAR_USUARIO;
    toReturn.ID_DEPARTAMENTO = data.ID_DEPARTAMENTO;
    toReturn.SERIE_DOCUMENTAL = data.SERIE_DOCUMENTAL;
    toReturn.NOMBRE_SERIE = data.NOMBRE_SERIE;
    toReturn.PROVEEDOR = data.PROVEEDOR;

    return toReturn;
  }
}

export class SolicitudesAprobadas extends Solicitudes {
  USUARIO_APROBACION: string;
  ID_USUARIO_APROBACION: number;

  constructor() {
    super();
  }

  static toModel(json: string): SolicitudesAprobadas {
    const toReturn = Solicitudes.toModel(json) as SolicitudesAprobadas;
    const data = JSON.parse(json);
    toReturn.USUARIO_APROBACION = data.USUARIO_APROBACION;
    toReturn.ID_USUARIO_APROBACION = data.ID_USUARIO_APROBACION;
    return toReturn;
  }
}

export class SolicitudesSearch {
  Id: number;
  ID_TIPO_SERVICIO: number;
  ESTADO: number;
  FECHA_CREACION_DESDE: string;
  FECHA_CREACION_HASTA: string;
  FECHA_SLA_DESDE: Date;
  FECHA_SLA_HASTA: Date;
  FECHA_FINALIZACION_DESDE: Date;
  FECHA_FINALIZACION_HASTA: Date;
  ID_GRUPO: number;
  ID_CLIENTE: number;
  PRIORIDAD: number;
  ID_USUARIO: number; // null lo ignora | =0 soy yo  |  >0 filtra por usuario,
  ORDENACION: string;
  ASC: boolean;
  PDTE_APROBACION?: boolean;
  PDTE_APROBAR_POR_USUARIO?: boolean;
  SITUACION: number;
  FECHA_FINALIZACION: Date;
  FECHA_FINALIZACION_COMPARATOR: number;
  ESTADISTICAS: number;
  //🥑
  SERIE_DOCUMENTAL: number;
  ID_DEPARTAMENTO: number;
  //🥑 PROVEEDOR
  ID_PROVEEDOR: number;
  filtrosAvanzados: any[];
  constructor() { }
}


export class FilterSolicitudes {
  constructor(public ID: number,
    public propertyFilter: string,
    public propertyForm: string,
    public stringTraslate: string,
    public initFormValue: any,
    public nameComboData?: string,
    public propertyInComboData?: string,
    public translateTextValue?: string,
    public textValue?: string) { }
}
